import React from 'react';

export const StatisticsPage: React.FC = () => (
  <div style={{ color: '#fff', maxWidth: '1200px' }}>
    <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px' }}>📈 통계</h1>
    <p style={{ color: 'rgba(255,255,255,0.4)', marginBottom: '32px' }}>A북/B북 성과 통계</p>
    <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', padding: '60px', textAlign: 'center' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚧</div>
      <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '16px' }}>통계 기능 개발 중입니다.</div>
      <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '13px', marginTop: '8px' }}>MT5 거래 데이터 연동 후 활성화됩니다.</div>
    </div>
  </div>
);

export const PatternPage: React.FC = () => (
  <div style={{ color: '#fff', maxWidth: '1200px' }}>
    <h1 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px' }}>🧠 패턴 분석</h1>
    <p style={{ color: 'rgba(255,255,255,0.4)', marginBottom: '32px' }}>트레이더 패턴 분석 및 B북 추천</p>
    <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: '16px', padding: '60px', textAlign: 'center' }}>
      <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚧</div>
      <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: '16px' }}>패턴 분석 기능 개발 중입니다.</div>
      <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: '13px', marginTop: '8px' }}>매일 새벽 2시 배치 분석 후 결과가 표시됩니다.</div>
    </div>
  </div>
);
